import { defineStore } from 'pinia';

export const useIndicatorStore = defineStore('indicator', {
  state: () => {
    return {
      isIndicator: false,
    };
  },
  getters: {},
  actions: {
    setIndicator(b: boolean) {
      this.isIndicator = b;
    },
  },
});
